// Runtime config — populated by /config.js (loaded before the bundle in
// index.html). In production the container entrypoint generates that file
// from a per-env ConfigMap. In dev the stub at public/config.js leaves
// APP_CONFIG empty and we fall back to import.meta.env (Vite reads .env
// files), preserving the existing local workflow.

type AppConfig = {
  API_HOST: string
  WEBSOCKET_HOST: string
  API_VERSION: string
  ENVIRONMENT: string
  SENTRY_ENV: string
  MAINTENANCE_MODE: boolean
}

declare global {
  interface Window {
    // Runtime values arrive as strings (envsubst output), so the window
    // shape is looser than the parsed AppConfig.
    APP_CONFIG?: Partial<Record<keyof AppConfig, string>>
  }
}

const fromWindow = typeof window !== 'undefined' ? window.APP_CONFIG : undefined

// Coerce a string flag to a boolean. Only 'true' enables; anything else
// (including 'false', unset, or an unrecognised value) is false, so a missing
// or malformed var never takes the site down.
export const parseBool = (raw: string | undefined): boolean => (raw ?? '').trim().toLowerCase() === 'true'

export const config: AppConfig = {
  API_HOST: fromWindow?.API_HOST || import.meta.env.REACT_APP_API_HOST,
  WEBSOCKET_HOST: fromWindow?.WEBSOCKET_HOST || import.meta.env.REACT_APP_WEBSOCKET_HOST,
  API_VERSION: fromWindow?.API_VERSION || import.meta.env.REACT_APP_API_VERSION,
  ENVIRONMENT: fromWindow?.ENVIRONMENT || import.meta.env.REACT_APP_ENVIRONMENT,
  SENTRY_ENV: fromWindow?.SENTRY_ENV || import.meta.env.REACT_APP_SENTRY_ENV,
  // `??` not `||`: the runtime value wins whenever the key is present — even
  // when envsubst injects an empty string for an unset prod env var, which
  // must read as "off" rather than falling back to a build-time flag. Only a
  // genuinely absent key (the dev `{}` stub) falls through to the Vite env.
  MAINTENANCE_MODE: parseBool(fromWindow?.MAINTENANCE_MODE ?? import.meta.env.REACT_APP_MAINTENANCE_MODE)
}

// Without these the app can't reach the API at all: every call goes to
// `undefinedundefined/...` on the app's own origin and nginx answers with
// index.html. That fails quietly (empty lists, a generic error toast), so the
// caller reports it instead.
export const missingConnectionConfig = (cfg: AppConfig): (keyof AppConfig)[] =>
  (['API_HOST', 'API_VERSION', 'WEBSOCKET_HOST'] as const).filter((key) => !cfg[key])
